export default (handler) => ({
  role: "button",
  onClick: handler,
  style: { cursor: "pointer" },
  onKeyDown: (event) => {
    // handle enter
    if (event.keycode === 13) handler(event);
  },
});
